import MuiTypography from "@mui/material/Typography";

/**
 * Facade over MUI Typography. Customize defaults here.
 */
export default function Typography(props) {
  return <MuiTypography {...props} />;
}
